import { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { companyMasterListAsync } from "../../../../redux/features/company-master/companyMasterSlice";
import toast from "react-hot-toast";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export default function CompanyMasterList() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const companyMasterList = useSelector((state) => state.companyMasterListSlice.data);

   const [records, setRecords] = useState([]);
   const columns = [
      {
         name: "Company Name",
         selector: (row) => row.company_name,
         sortable: true,
      },
      {
         name: "Company Pan",
         selector: (row) => row.company_pan,
         sortable: true,
      },

      {
         name: "Company GST",
         selector: (row) => row.company_gst,
         sortable: true,
      },

      {
         name: "Address",
         selector: (row) => row.address,
         sortable: true,
      },

      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/company-master/edit/${row.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
               </div>
            );
         },
      },
   ];

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         companyMasterListAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   useEffect(() => {
      if (companyMasterList) setRecords(companyMasterList);
   }, [companyMasterList]);

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = companyMasterList?.filter((item) => {
         return (
            item?.company_name?.toLowerCase().includes(searchText) ||
            item?.company_pan?.toLowerCase().includes(searchText) ||
            item?.company_gst?.toLowerCase().includes(searchText) ||
            item?.address?.toLowerCase().includes(searchText)
         );
      });
      setRecords(newData);
   };

   return (
      <div>
         <BodyHeader title="Company Master List" />

         <div className="px-3">
            <div className="d-flex justify-content-start">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
